"use client"

import { useEffect, useState, memo } from "react"
import MainLayout from "@/layout/MainLayout"
import StandardCard from "@/components/cards/StandardCard"
import { LISTING_GRID_CLASS, renderNewsGridWithAds } from "@/components/ListingGridWithAds"
import axiosInstance from "@/lib/axios"
import PageHeader from "@/components/ui/PageHeader"
import { LISTING_NEWS_PER_PAGE } from "@/lib/advertisement/constants"
import { CardGridSkeleton, EmptyState } from "@/components/ui/Skeleton"
import Pagination from "@/components/ui/Pagination"

const AllNews = ({ initialData = null }) => {
    const [news, setNews] = useState(() => initialData?.data || [])
    const [pagination, setPagination] = useState(() => initialData?.pagination || {})
    const [loading, setLoading] = useState(() => initialData == null)
    const [currentPage, setCurrentPage] = useState(1)

    const fetchAllNews = async (page = 1) => {
        try {
            setLoading(true)
            const response = await axiosInstance.get('/news/all', {
                params: { page, limit: LISTING_NEWS_PER_PAGE }
            })
            if (response.data.success) {
                setNews(response.data.data)
                setPagination(response.data.pagination)
            }
        } catch (error) {
            console.error("Error fetching all news:", error)
        } finally {
            setLoading(false)
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    useEffect(() => {
        if (!initialData) return
        if (initialData.page !== 1) return
        setNews(initialData.data || [])
        setPagination(initialData.pagination || {})
        setLoading(false)
        setCurrentPage(1)
    }, [initialData])

    useEffect(() => {
        if (currentPage === 1 && initialData?.page === 1) return
        fetchAllNews(currentPage)
        // eslint-disable-next-line react-hooks/exhaustive-deps -- page-driven fetch
    }, [currentPage, initialData?.page])

    return (
        <MainLayout>
            <PageHeader
                title="सर्व बातम्या"
                description="संपूर्ण महाराष्ट्रातील सर्व बातम्या."
                accentName="All"
            />

            {loading && !news.length ? (
                <CardGridSkeleton count={9} />
            ) : news.length > 0 ? (
                <>
                    <div className={LISTING_GRID_CLASS}>
                        {renderNewsGridWithAds(news, 'all_news', (item) => (
                            <StandardCard
                                key={item.id}
                                layout="col"
                                headline={item.title}
                                imageUrl={item.featuredImage}
                                data={item}
                            />
                        ))}
                    </div>

                    {pagination.totalPages > 1 && (
                        <div className="mt-12">
                            <Pagination
                                currentPage={pagination.currentPage}
                                totalPages={pagination.totalPages}
                                onPageChange={setCurrentPage}
                            />
                        </div>
                    )}
                </>
            ) : (
                <EmptyState message="कोणतीही बातमी सापडली नाही." />
            )}
        </MainLayout>
    )
}

export default memo(AllNews)
